<template>
  <div>
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card class="pb-2">
        <v-card-title class="primary white--text">
          <span style="width: 100%">
            {{ add ? "Add" : "Update" }} Letter Template
            <v-btn
              class="primary lighten-1 float-right"
              dark
              icon
              small
              @click="
                $emit('cancel');
                reset();
              "
            >
              <v-icon color="white--text" small>mdi-close</v-icon>
            </v-btn>
          </span>
        </v-card-title>
        <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
          <v-card-text class="pa-5 mt-2">
            <vonex-text
              v-model="letterTemp.title"
              label="Title"
              outlined
              name="Letter title"
              :rule="'required'"
            ></vonex-text>
            <v-file-input
              v-model="files"
              ref="files"
              data-cy="fileUpload"
              color="primary"
              class="d-flex mr-2"
              counter
              label="Upload letter template"
              placeholder="Select file"
              hint="Only upload .docx files"
              outlined
              type="file"
              multiple
              :show-size="1000"
              accept=".docx"
              :success="success"
              :error="error"
              :success-messages="successMsg"
              :error-messages="errorMsg"
            >
              <template v-slot:selection="{ index, text }">
                <v-chip v-if="index < 5" color="primary" dark label small>{{
                  text
                }}</v-chip>
              </template>
            </v-file-input>
          </v-card-text>

          <v-divider class="primary ma-auto" width="91%"></v-divider>

          <v-card-actions class="py-5 px-5">
            <v-spacer></v-spacer>
            <v-btn
              class="primary"
              dark
              text
              @click="
                submit();
                reset();
              "
              :disabled="invalid"
              >{{ add ? "Submit" : "Update" }}</v-btn
            >
            <v-btn
              class="primary"
              dark
              text
              @click="
                $emit('cancel');
                reset();
              "
              :disabled="disable"
              >Cancel</v-btn
            >
          </v-card-actions>
        </ValidationObserver>
      </v-card>
      <v-dialog v-model="loadingDialog" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-3 white--text">
            Please stand by
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-dialog>
    <message-alert
      :component="$store.getters[`template/message`]"
    ></message-alert>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { LetterTemplate } from "../../models/LetterTemplate";

export default {
  name: "LetterDialog",
  data: () => ({
    success: false,
    loadingDialog: false,
    disable: false,
    letterTemp: new LetterTemplate(),
    err: "",
    files: [],
    error: false,
  }),

  props: {
    dialog: { type: Boolean },
    template: { type: Object },
    add: { type: Boolean },
  },
  watch: {
    dialog(val) {
      if (val && !this.add) {
        this.letterTemp = this.template;
      }
      return val;
    },
    template: {
      deep: true,
      handler(val) {
        if (val) {
          this.letterTemp = val;
        }
      },
    },
  },
  methods: {
    ...mapActions("template", [
      "updateTemplate",
      "addLetterTemplate",
      "setMessage",
    ]),
    update() {
      this.loadingDialog = true;
    },
    submit() {
      let vm = this;
      let formData = new FormData();
      vm.loadingDialog = true;
      vm.$refs.files.value.forEach((x) =>
        formData.append("letterTemplateDocx", x)
      );
      formData.append("id", vm.letterTemp.id);
      formData.append("title", vm.letterTemp.title);
      formData.append("docFile", vm.letterTemp.docFile);

      vm.$refs.observer.validate().then(async (valid) => {
        if (valid) {
          vm.err = "";
          vm.addLetterTemplate(formData)
            .then(() => {
              vm.letterTemp = new LetterTemplate();
              vm.loadingDialog = false;
              vm.$refs.observer.reset();
              vm.$emit("done");
            })
            .catch((err) => {
              vm.err = err;
              vm.loadingDialog = false;
            });
        }
      });
    },
    reset() {
      this.success = false;
      this.letterTemp.title = "";
      this.files = [];
      this.disable = false;
    },
  },
  computed: {
    successMsg() {
      return this.success ? ["File successfully imported"] : [];
    },
    errorMsg() {
      return this.error ? ["Failed to import file"] : [];
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-banner__wrapper {
  padding: 0 0 15px !important;
}
</style>
